import { Footer } from '@/shared/components/layout/Footer';
import React from 'react';

const Step3 = ({ onStart, onBack }) => {
    return (
        <div className="vitals-wrapper">
            <div className="container-vitals-top">
                <section className="section-vitals-top form-steps">
                    {/* Barra de Progreso - Paso 3 Finalizado */}
                    <div className="steps-wrapper step-3">
                        <div className="steps-bar">
                            <div className="steps-progress"></div>
                        </div>

                        <div className="steps-labels">
                            <span>Paso 1</span>
                            <span>Paso 2</span>
                            <span>Paso 3</span>
                        </div>
                    </div>
                    <div className="form-vitals">
                        <div className="arrow-back" onClick={onBack}>
                            <i className="icon icon_enlinea_flechita-izq back-card"></i>
                        </div>
                        <div className="title-vitals mt-8">
                            ¡Todo listo para tu chequeo!
                        </div>

                        <span className="text-vitals mt-3">
                            Presiona <b>“Permitir”</b> cuando te solicite permiso <br /> de utilizar la cámara.
                        </span>
                        <div className="info-scan">
                            <img src={window.innerWidth > 1024 ? "/img/instrucciones.gif" : "/img/instruccionesv2.gif"} alt="Loading..." className="scan-gif" />

                            <div className="text-vitals-left">
                                <ul>
                                    <li>Retírate elementos como gafas, gorro o tapabocas</li>
                                    <li>Ubícate en un lugar con fondo claro y <b>bien iluminado</b></li>
                                    <li>Mantén el rostro visible y sin movimiento</li>
                                </ul>
                            </div>

                            <button
                                type="button"
                                className="btn vitals-primary mt-8"
                                onClick={onStart}
                            >
                                Continuar
                            </button>
                        </div>

                    </div>

                </section>
            </div>

            <Footer/>
        </div>
    );
};

export { Step3 };